export default "__VITE_ASSET__CxD9xer5__"